import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackCopiedShareLink } from "@air/analytics";
import { memo, useMemo } from "react";
import { CopyLinkButton } from "~/components/SharePrivateContentModal/CopyLinkButton";
import { SharePrivateContentLink } from "~/components/SharePrivateContentModal/SharePrivateContentLink";
import { PRIVATE_SHARE_EDITABLE_LINK } from "~/constants/testIDs";
import { getFullShareUrl } from "~/utils/shareUrl";
export const EditableSharePrivateLink = /*#__PURE__*/ memo((param)=>{
    let { createdAt, createdBy, objectId, trackLocation, shareId, searchParams, objectType, onRegenerate } = param;
    const { trackCopiedShareLink } = useTrackCopiedShareLink();
    const shareUrl = getFullShareUrl(shareId, searchParams);
    const onCopied = ()=>{
        trackCopiedShareLink({
            id: objectId,
            shareId,
            type: objectType,
            location: trackLocation
        });
    };
    const actions = useMemo(()=>[
            {
                id: "regenerate",
                label: "Generate a new link",
                type: "item",
                onSelect: ()=>onRegenerate()
            }
        ], [
        onRegenerate
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": PRIVATE_SHARE_EDITABLE_LINK,
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ _jsx(SharePrivateContentLink, {
                createdAt: createdAt,
                createdBy: createdBy,
                shareUrl: shareUrl,
                menuActions: actions
            }),
            /*#__PURE__*/ _jsx(CopyLinkButton, {
                shareUrl: shareUrl,
                onCopied: onCopied
            })
        ]
    });
});
EditableSharePrivateLink.displayName = "EditableSharePrivateLink";
